<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Alert Type:</label>
	<p-dropdown
		[options]="lstAlertType"
		[(ngModel)]="AlertType"
		optionLabel="AlertTypeFullDesc"
		[filter]="true"
		filterBy="AlertTypeFullDesc"
		[showClear]="false"
		placeholder="Select an Alert Type"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="AlertType">
				<div class="form-control NoBorder" style="text-align: left" [style.color]="GetColor(AlertType)">
					{{ AlertType.AlertTypeFullDesc }}
				</div>
			</div>
		</ng-template>
		<ng-template let-AlertTypeItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left" [style.color]="GetColor(AlertTypeItem)">
					{{ AlertTypeItem.AlertTypeFullDesc }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Start Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate"></p-calendar>

	<label>Start Time:</label>
	<p-calendar showIcon="true" showButtonBar="true" timeOnly="true" showTime="true" hourFormat="12" [(ngModel)]="StartTime" name="StartTime"></p-calendar>

	<label>Set End Date/Time:</label>
	<div style="text-align: left">
		<input style="width: 25px; height: 25px" type="checkbox" [(ngModel)]="SetEnd" class="form-control" />
	</div>

	<label *ngIf="SetEnd == true">End Date:</label>
	<p-calendar *ngIf="SetEnd == true" showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate"></p-calendar>

	<label *ngIf="SetEnd == true">End Time:</label>
	<p-calendar
		*ngIf="SetEnd == true"
		showIcon="true"
		showButtonBar="true"
		timeOnly="true"
		showTime="true"
		hourFormat="12"
		[(ngModel)]="EndTime"
		name="EndTime"
	></p-calendar>

	<label>Message:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="Comments"></textarea>
</div>

<!--Buses-->
<div class="BusDiv">
	<h4>Buses to send alert to:</h4>

	<caass-school-bus-alert-bus-table [lstSelectedFromMain]="lstSelectedFromMain"> </caass-school-bus-alert-bus-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" class="btn btn-primary" (click)="onAdd()">Send Alert</button>
	<button class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
